import React from "react"
import {useTranslation} from "react-i18next";

import LockingSystem from "../../types/LockingSystem"
import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react";
import DateTimeListItem from "../common/ListItems/DateTime";

export interface componentProps {
    item: LockingSystem
}

const ItemGroupApiLink: React.FC<componentProps> = ({item}) => {

    const { t } = useTranslation()

    return (
        <IonItemGroup className="ion-margin-top" key={'location-system-' + item.id + '-api-link'}>
            <IonItemDivider>{t('locking-systems.api_link')}</IonItemDivider>
            <DateTimeListItem label={t('common.active_since').toString()}
                              dateTime={item.lockingSystemApi?.createdAt} />
            <IonItem>
                <IonLabel>API ClientID</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {item.lockingSystemApi?.clientId ? item.lockingSystemApi?.clientId : '-'}
                </IonNote>
            </IonItem>
            <IonItem>
                <IonLabel>API UserName</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {item.lockingSystemApi?.userName ? item.lockingSystemApi?.userName : '-'}
                </IonNote>
            </IonItem>
            {/*{item.lockingSystemApi &&*/}
            {/*<IonItem key="api-sync" lines="full">*/}
            {/*    <IonLabel>*/}
            {/*        {t('locking-systems.api_sync_manual')}*/}
            {/*    </IonLabel>*/}
            {/*    {! isSynchronizing &&*/}
            {/*    <IonButton color="bc-yellow" size="small" style={{ 'height': '32px' }} fill="outline"*/}
            {/*               onClick={(ev) => handleSync(ev)}*/}
            {/*               slot="end">*/}
            {/*        Sync alles*/}
            {/*    </IonButton>*/}
            {/*    }*/}
            {/*</IonItem>*/}
            {/*}*/}
        </IonItemGroup>
    )
}

export default ItemGroupApiLink